<template>
  <div class="qr-preview-wrap">
    <div class="qr-preview">
      <img v-if="src" :src="src" alt="" />
      <WorkbenchIcon v-else name="qr-code" :size="84" />
    </div>
  </div>
</template>

<script setup lang="ts">
import WorkbenchIcon from '@/components/Workbench/WorkbenchIcon.vue'

defineProps<{ src: string }>()
</script>

<style scoped lang="scss">
.qr-preview-wrap {
  display: flex;
  justify-content: center;
  padding: 4px 0;
}

.qr-preview {
  display: flex;
  box-sizing: border-box;
  width: 132px;
  height: 132px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 1px solid #e3e7ec;
  border-radius: 10px;
  background: #f7f9fc;
  color: #1f2329;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
</style>
